// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__2ZJoL","bodyContainer":"App_bodyContainer__q7JPX","footerContainer":"App_footerContainer__mLB5N"};